'use client';
import { useRouter } from 'next/navigation'

const StartExamBtn = ({children}: {children: React.ReactNode}) => {

    const router = useRouter()

    return <>
        <button
            onClick={async () => {
              let gotAccessToAudio = false;
              try {
                await navigator.mediaDevices.getUserMedia({ audio: true })
                gotAccessToAudio = true;
              } catch (error) {
                gotAccessToAudio = false;
              }
              
              if (gotAccessToAudio) {
                router.push('/speaking/exam')
              } else {
                // TODO: show a message to the user
                // TODO: handle each case properly (e.g. user did not give us access, there is no mic, etc)
              }
            }}
            className="max-w-fit py-2 px-4 border border-transparent rounded-full shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >{children}</button>
    </>
}

export default StartExamBtn;